import { CoverImageDisplayMode } from './types'

// How far `.kuiper-isScrolled` lifts the week view over the histogram. The
// lifted day rows grow by the same amount.
export const WEEK_VIEW_SCROLL_OFFSET = 54

// These pixel values must be represented by the total CSS dimensions in viewport to work
export const spacingParams = {
  POST_HEIGHT: 28, // the standard height of an expanded piece of content
  CONTENT_SUMMARY_HEIGHT: 37, // the height of content summary line
  MOMENT_HEIGHT: 78, // the default height of a moment
  MOMENT_HEIGHT_SMALL: 58, // the height of a "small" moment
  EMPTY_MOMENT_PADDING: 10, // the added bottom padding for empty moments
  EMPTY_WORKFLOW_STATUS_HEIGHT: 28, // the height of workflow status in an empty moment card
  PRIVATE_SMALL_MOMENT_HEIGHT: 88, // the height of the privacy icon and padding for private moments
  WORKFLOW_STATUS_HEIGHT: 24, // the height of the workflow status line
  EXPANDED_TITLE_HEIGHT: 40, // the added height of moment with an expanded title
  EXPANDED_TITLE_THRESHOLD: 37, // how many characters long the title must be before it is expanded to 4 lines
  DATE_HEIGHT: 18, // the height of a date line, if a moment has an end date
  IMAGE_PLACEHOLDER_HEIGHT: 69, // the difference in default height between a moment with and without an image
  CELL_PADDING: 20, // the total space betwen moments (same horizontal and vertical)
  MOMENT_VERTICAL_IMAGE_MARGIN: 106, // the difference in height between a moment card and its preview image
  MOMENT_BORDER_WIDTH: 4, // total width of the border on a moment card
  COVERIMAGE_WIDTH: 250, // the width the frontend should resize a fullsize asset
  WEEKVIEW_OUTERPADDING: 38, // the difference in width of the weekview component and the 7 columns of momentcards
}

// Every bucket state apart from standard needs height/offset bucketizing
export const customBuckets = [
  {
    name: `day-buckets-${CoverImageDisplayMode.NoImage}`,
    momentScale: CoverImageDisplayMode.NoImage,
    isExpanded: false,
  },
  {
    name: `day-buckets-${CoverImageDisplayMode.NoImage}-expanded`,
    momentScale: CoverImageDisplayMode.NoImage,
    isExpanded: true,
  },
  {
    name: `day-buckets-${CoverImageDisplayMode.Standard}`,
    momentScale: CoverImageDisplayMode.Standard,
    isExpanded: false,
  },
  {
    name: `day-buckets-${CoverImageDisplayMode.Standard}-expanded`,
    momentScale: CoverImageDisplayMode.Standard,
    isExpanded: true,
  },
  {
    name: `day-buckets-${CoverImageDisplayMode.Scaled}`,
    momentScale: CoverImageDisplayMode.Scaled,
    isExpanded: false,
  },
  {
    name: `day-buckets-${CoverImageDisplayMode.Scaled}-expanded`,
    momentScale: CoverImageDisplayMode.Scaled,
    isExpanded: true,
  },
]
